import script from "./ViewQuestionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewQuestionView.vue?vue&type=script&setup=true&lang=ts"

import "./ViewQuestionView.vue?vue&type=style&index=0&id=0444e5ac&lang=css"

const __exports__ = script;

export default __exports__